export const USER_EXISTS_ERROR_CODE = '003-003';
export const FORBIDDEN_EMAIL_DOMAIN_ERROR_CODE = '002-036';
export const INVALID_EMAIL_ERROR_CODE = '010-018';
